'use client';
import { Space, Stack } from '@mantine/core';
import BookingAlert from './components/booking-alert';
import BookingPaths from './components/paths';
import BikeSpecialRequests from '@/features/booking/components/bike-special-request/special-request';
import BookingConfirmOrder from '@/features/booking/components/booking-confirm-order';
import HmService from '@/features/booking/components/house-moving/house-moving-service';
import { useTruckService } from '@/features/booking/components/services/use-truck-service';
import TruckBulkyPackageDetail from '@/features/booking/components/truck/truck-package-detail/truck-bulky-package-detail';
import TruckPackageDetail from '@/features/booking/components/truck/truck-package-detail/truck-package-detail';
import TruckService from '@/features/booking/components/truck/truck-service/truck-service';

export default function HouseMovingContainer() {
  const { isHiddenHm } = useTruckService();
  return (
    <>
      <Stack gap="md" px="md" w="100%">
        {/* <BookingAlert /> */}

        <BookingPaths />
        <HmService />
        <BikeSpecialRequests />
      </Stack>

      <Space className="h-48 md:h-72" />
      {!isHiddenHm && <BookingConfirmOrder />}
    </>
  );
}
